import { type IOptionProps } from '@interface/ICommon';
import { clickSaveBtn } from '@store/commonSlice';
import { useAppDispatch } from '@store/index';
import classNames from 'classnames';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import EventType from './EventType';
import Level from './Level';
import Reset from './Reset';

const AsideContainer: FC<{ props: IOptionProps }> = ({ props }) => {
    const { isShowAsideMenu, toggleAsideMenu, activeEvtType, activeMin, activeMax } = props;
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    return (
        <aside
            className={classNames(
                {
                    block: isShowAsideMenu,
                    hidden: !isShowAsideMenu,
                },
                'px-[16px] py-[40px] bg-black08 fixed left-0 top-0 z-[9999999] w-full h-full reset-style lg:px-0'
            )}
        >
            <section className="w-[100%] h-[100%] bg-bg rounded-[4px] lg:p-0 lg:m-0">
                <Reset />
                <div className="h-[100%] mt-[-67px] mb-[-50px] pt-[67px] pb-[50px] ">
                    <div className="h-[100%] overflow-y-scroll scroll-smooth lg:h-auto lg:overflow-y-auto">
                        <form onSubmit={(event) => event.preventDefault()}>
                            <Level activeMin={activeMin} activeMax={activeMax} toggleAsideMenu={toggleAsideMenu} />
                            <EventType activeEvtType={activeEvtType} />
                        </form>
                    </div>
                </div>
                <button
                    className="h-[50px] block w-full text-lg15 text-white text-center pt-[13px] pb-[14px] bg-point rounded-b-[4px] lg:hidden"
                    onClick={() => dispatch(clickSaveBtn())}
                >
                    {t('I004')}
                </button>
            </section>
        </aside>
    );
};
export default AsideContainer;
